import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import styled from "styled-components";
import GlobalStyle from "./styles/GlobalStyles";
import Header from "./components/Header";
import Footer from "./components/Footer";

// Page components
import Hero from "./components/Hero";
import AboutUs from "./components/Aboutus";
import Features from "./components/Features";
import HowItWorks from "./components/HowItWorks";
import LogIn from "./components/LogIn";
import Register from "./components/Register";
import ExploreMore from "./components/ExploreMore";
import ViewMore from "./components/ViewMore";
import Discover from "./components/Discover";
import UIUXDesign from "./components/UIUXDesign";
import WebDevelopment from "./components/WebDevelopment";
import DatabaseManagement from "./components/DatabaseManagement";
import Marketing from "./components/marketing";
import Career from "./components/Career";
import Contact from './components/Contact';
import CareerPage from './components/CareerPage';
import CareerPath from './components/CareerPath';
import JobReadyProgram from "./components/JobReadyProgram";
import TwoYearProgram from "./components/TwoYearProgram";
import ThreeYearProgram from "./components/ThreeYearProgram";

// Wrapper styling
const ContentWrapper = styled.div`
  padding-top: 60px;
  background-color: white;

  @media (max-width: 768px) {
    padding-top: 60px;
  }
`;

// Home page component
const Home = () => (
  <>
    <Hero />
    <AboutUs />
    <Features />
    <HowItWorks />
    <LogIn />
  </>
);

// Component to conditionally render Footer
const FooterWrapper = () => {
  const location = useLocation();

  // Add any route where footer shouldn't appear
  const noFooterRoutes = ['/career-path'];
  const showFooter = !noFooterRoutes.includes(location.pathname);

  return showFooter ? <Footer /> : null;
};

// Main App component
const App = () => {
  return (
    <Router>
      <GlobalStyle />
      <Header />
      <ContentWrapper>
        <Routes>
          {/* Public Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/service" element={<Features />} />
          <Route path="/explore-more" element={<ExploreMore />} />
          <Route path="/view-more" element={<ViewMore />} />
          <Route path="/discover" element={<Discover />} />
          <Route path="/ui-ux-design" element={<UIUXDesign />} />
          <Route path="/web-development" element={<WebDevelopment />} />
          <Route path="/database-management" element={<DatabaseManagement />} />
          <Route path="/marketing" element={<Marketing />} />

          {/* Career Pages */}
          <Route path="/career" element={<Career />} />
          <Route path="/careerpage" element={<CareerPage />} />
          <Route path="/career-path" element={<CareerPath />} />
          <Route path="/job-ready-program" element={<JobReadyProgram />} />
          <Route path="/two-year-program" element={<TwoYearProgram />} />
          <Route path="/three-year-program" element={<ThreeYearProgram />} />

          {/* Authentication Pages */}
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<LogIn />} />
        </Routes>
      </ContentWrapper>
      <FooterWrapper />
    </Router>
  );
};

export default App;
